import { render, staticRenderFns } from "./tenant-long-term-obligations-details.vue?vue&type=template&id=50d59a29"
import script from "./tenant-long-term-obligations-details.vue?vue&type=script&lang=js"
export * from "./tenant-long-term-obligations-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports